









import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import ErrorNotification from '@/components/shared/ErrorNotification.vue';
import { DocumentModel, EditReferencesRouteTypes, ErrorModel, NotificationPresentationType } from '@/types';
import DefaultEditReferences from '@/components/editReferences/DefaultEditReferences.vue';
import { EditReferencesComponents, DocumentToStoreSearchModel } from '@/types';
import SelectExistingDocument from '@/components/documentToStore/SelectExistingDocument.vue';
import DocumentLock from '@/components/editReferences/DocumentLock.vue';
import { FeatureToggleService } from '@/services/FeatureToggleService';
import { EventListenerUtils } from '@/utils/eventListenerUtils';

export default Vue.extend({
  name: 'EditReferences',
  data() {
    return {
      lastActivity: new Date()
    };
  },
  components: {
    LoadingSpinner,
    ErrorNotification,
    DefaultEditReferences,
    DocumentLock,
    SelectExistingDocument
  },
  methods: {
    ...mapActions('editReferencesStore', ['getDocumentToStore', 'setComponentName', 'setIsLoading', 'releaseDocumentToStoreLock', 'setTargetDocumentTypeId']),
    ...mapActions('documentViewStore', ['unloadDocument']),
    async initialise(this: any) {
      const toggle = await FeatureToggleService.getFeatureToggle('EditReferences');
      const featureEnabled = toggle.toString().toLowerCase();
      if (featureEnabled !== 'true') {
        this.$router.push({
          name: 'errorPage',
          params: {
            errorCode: '401',
            errorMessage: 'Sorry, you do not have permission to access this page',
            notificationPresentationType: NotificationPresentationType.UserActionRequired
          }
        });
      }

      this.getDocumentToStore({
        sourceCabinetId: this.cabinetId,
        sourceDocumentId: this.documentId
      } as DocumentToStoreSearchModel);
    },
    onExpiryModalButtonClicked(this: any) {
      const returnUrl = sessionStorage.getItem(EditReferencesRouteTypes.ReturnUrl);
      if (returnUrl) {
        window.location.href = returnUrl;
      } else {
        const returnRoute = sessionStorage.getItem(EditReferencesRouteTypes.ReturnRoute);
        this.$router.push({
          path: returnRoute || '/'
        });
      }
    },
    userActivity(this: any) {
      this.lastActivity = new Date();
    },
    getComponentProps(this: any) {
      switch (this.componentName) {
        case EditReferencesComponents.SelectExistingDocument:
          return { storeNamespace: 'editReferencesStore' };
        case EditReferencesComponents.Error:
          let buttonRouteName;
          let buttonRouteParams;
          let buttonRoutePath;
          if (sessionStorage.getItem(EditReferencesRouteTypes.ReturnRoute)) {
            const resolvedRoute = this.$router.resolve(sessionStorage.getItem(EditReferencesRouteTypes.ReturnRoute));
            buttonRouteName = resolvedRoute.route.name || 'DefaultRoute';
            buttonRouteParams = resolvedRoute.route.params;
          } else if (sessionStorage.getItem(EditReferencesRouteTypes.ReturnUrl)) {
            buttonRoutePath = sessionStorage.getItem(EditReferencesRouteTypes.ReturnUrl);
          } else {
            buttonRouteName = 'DefaultRoute';
          }
          return {
            errorModel: {
              ...this.errorModel,
              buttonRoutePath,
              buttonRouteName,
              buttonRouteParams
            } as ErrorModel
          };
        default:
          return {};
      }
    }
  },
  computed: {
    ...mapGetters('editReferencesStore', ['documentToStore', 'isLoading', 'componentName', 'errorModel', 'entityLock']),
    ...mapGetters('documentViewStore', ['document', 'deletedDocumentId']),
    documentId: {
      get(this: any) {
        return Number(this.$route.params.sourceDocumentId);
      }
    },
    cabinetId: {
      get(this: any) {
        return this.$route.params.sourceCabinetId;
      }
    },
    hasDocumentLock() {
      return !this.isLoading && this.entityLock && this.componentName !== EditReferencesComponents.Error;
    }
  },
  created(this: any) {
    EventListenerUtils.addBeforeUnloadEvent(this.releaseDocumentToStoreLock);
    this.routeDocumentId = Number(this.$route.params.sourceDocumentId);
  },
  beforeDestroy(this: any) {
    this.unloadDocument();
    if (this.deletedDocumentId !== this.routeDocumentId) {
      this.releaseDocumentToStoreLock();
    }
    this.setTargetDocumentTypeId(null);
    EventListenerUtils.removeBeforeUnloadEvent(this.releaseDocumentToStoreLock);
    this.setComponentName(null);
    sessionStorage.removeItem(EditReferencesRouteTypes.ReturnUrl);
    sessionStorage.removeItem(EditReferencesRouteTypes.ReturnRoute);
  },
  mounted() {
    this.initialise();
  }
});
